import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { boronClient } from "../../api";
import { createError, HTTPErrors } from "../../errors";
import { StudentFilterParams } from "../../helpers/FiltersHelper";
import type { DrillSectionContentsResponse } from "./types";

const path =
  "/api/v1/sections/{section_id}/drill_learning_materials/{steak_material_code}/drill_sections/{drill_section_public_id}/contents" as const;

type Props = {
  sectionId: string;
  materialCode?: string;
  drillSectionPublicId?: string;
  studentFilterParams: StudentFilterParams;
};

export const useFetchDrillSectionContents = ({
  sectionId,
  materialCode,
  drillSectionPublicId,
  studentFilterParams,
}: Props) => {
  return useQuery<DrillSectionContentsResponse, HTTPErrors>({
    queryKey: [
      "drillSectionContents",
      sectionId,
      materialCode,
      drillSectionPublicId,
      studentFilterParams,
    ],
    queryFn: async () => {
      const { response } = await boronClient.GET(path, {
        params: {
          path: {
            section_id: sectionId,
            steak_material_code: materialCode!,
            drill_section_public_id: drillSectionPublicId!,
          },
          query: studentFilterParams as Record<string, unknown>,
        },
      });

      if (response.ok) {
        return response.json() as Promise<DrillSectionContentsResponse>;
      }

      throw await createError(response);
    },
    retry: 0,
    placeholderData: keepPreviousData,
    enabled: materialCode !== undefined && drillSectionPublicId !== undefined,
  });
};
